<template>
    <section>
        <h1>{{ $t("سياسة الخصوصية") }}</h1>
        <div class="content">
            <div class="side">
                <article>
                    <h4>الخصوصية وبيان سريّة المعلومات</h4>
                    <p>
                        نقدر مخاوفكم واهتمامكم بشأن خصوصية بياناتكم على شبكة
                        الإنترنت. لقد تم إعداد هذه السياسة لمساعدتكم في تفهم
                        طبيعة البيانات التي نقوم بتجميعها منكم عند زيارتكم
                        لموقعنا على شبكة الانترنت وكيفية تعاملنا مع هذه البيانات
                        الشخصية.
                    </p>
                </article>
                <article>
                    <h4>التصفح</h4>
                    <p>
                        لم نقم بتصميم هذا الموقع من أجل تجميع بياناتك الشخصية من
                        جهاز الكمبيوتر الخاص بك أثناء تصفحك لهذا الموقع, وإنما
                        سيتم فقط استخدام البيانات المقدمة من قبلك بمعرفتك ومحض
                        إرادتك.
                    </p>
                </article>
                <article>
                    <h4>عنوان بروتوكول شبكة الإنترنت (IP)</h4>
                    <p>
                        في أي وقت تزور فيه اي موقع الكتروني بما فيها هذا الموقع
                        , سيقوم السيرفر المستضيف بتسجيل عنوان بروتوكول شبكة
                        الإنترنت (IP) الخاص بك , تاريخ ووقت الزيارة ونوع متصفح
                        الإنترنت الذي تستخدمه والعنوان URL الخاص بأي موقع من
                        مواقع الإنترنت التي تقوم بإحالتك الى هذا الموقع على
                        الشبكة.
                    </p>
                </article>
                <article>
                    <h4>إفشاء المعلومات لأي طرف ثالث</h4>
                    <p>
                        لن نقوم ببيع , المتاجرة , تأجير , أو إفشاء أية معلومات
                        لمصلحة أي طرف ثالث خارج هذا الموقع, أو المواقع التابعة
                        له.وسيتم الكشف عن المعلومات فقط في حالة صدور أمر بذلك من
                        قبل أي سلطة قضائية أو تنظيمية.
                    </p>
                </article>
                <article>
                    <h4>التعديلات على سياسة سرية وخصوصية المعلومات</h4>
                    <p>
                        نحتفظ بالحق في تعديل بنود وشروط سياسة سرية وخصوصية
                        المعلومات إن لزم الأمر ومتى كان ذلك ملائماً. سيتم تنفيذ
                        التعديلات هنا وسيتم بصفة مستمرة إخطارك بالبيانات التي
                        حصلنا عليها , وكيف سنستخدمها والجهة التي سنقوم بتزويدها
                        بهذه البيانات.
                    </p>
                </article>
                <article>
                    <h4>عند الاتصال بنا</h4>
                    <p>
                        سيتم التعامل مع كافة البيانات المقدمة من قبلك على أساس
                        أنها سرية . تتطلب النماذج التي يتم تقديمها مباشرة على
                        الشبكة تقديم البيانات التي ستساعدنا في تحسين موقعنا.سيتم
                        استخدام البيانات التي يتم تقديمها من قبلك في الرد على
                        كافة استفساراتك , ملاحظاتك , أو طلباتك من قبل هذا الموقع
                        أو أيا من المواقع التابعة له .
                    </p>
                </article>
            </div>
            <div class="side">
                <article>
                    <h4>عمليات المسح على الشبكة</h4>
                    <p>
                        إن عمليات المسح التي نقوم بها مباشرة على الشبكة تمكننا
                        من تجميع بيانات محددة مثل البيانات المطلوبة منك بخصوص
                        نظرتك وشعورك تجاه موقعنا.تعتبر ردودك ذات أهمية قصوى ,
                        ومحل تقديرنا حيث أنها تمكننا من تحسين مستوى موقعنا, ولك
                        كامل الحرية والإختيار في تقديم البيانات المتعلقة بإسمك
                        والبيانات الأخرى.
                    </p>
                </article>
                <article>
                    <h4>الروابط بالمواقع الأخرى على شبكة الإنترنت</h4>
                    <p>
                        قد يشتمل موقعنا على روابط بالمواقع الأخرى على شبكة
                        الإنترنت. او علانات من مواقع اخرى مثل Google AdSense ولا
                        نعتبر مسئولين عن أساليب تجميع البيانات من قبل تلك
                        المواقع, يمكنك الاطلاع على سياسات السرية والمحتويات
                        الخاصة بتلك المواقع التي يتم الدخول إليها من خلال أي
                        رابط ضمن هذا الموقع. نحن قد نستعين بشركات إعلان لأطراف
                        ثالثة لعرض الإعلانات عندما تزور موقعنا على الويب. يحق
                        لهذه الشركات أن تستخدم معلومات حول زياراتك لهذا الموقع
                        ولمواقع الويب الأخرى (باستثناء الاسم أو العنوان أو عنوان
                        البريد الإلكتروني أو رقم الهاتف)، وذلك من أجل تقديم
                        إعلانات حول البضائع والخدمات التي تهمك.
                    </p>
                </article>
                <article>
                    <h4>إفشاء المعلومات</h4>
                    <p>
                        سنحافظ في كافة الأوقات على خصوصية وسرية كافة البيانات
                        الشخصية التي نتحصل عليها. ولن يتم إفشاء هذه المعلومات
                        إلا إذا كان ذلك مطلوباً بموجب أي قانون أو عندما نعتقد
                        بحسن نية أن مثل هذا الإجراء سيكون مطلوباً أو مرغوباً فيه
                        للتمشي مع القانون , أو للدفاع عن أو حماية حقوق الملكية
                        الخاصة بهذا الموقع أو الجهات المستفيدة منه.
                    </p>
                </article>
                <article>
                    <h4>البيانات اللازمة لتنفيذ المعاملات المطلوبة من قبلك</h4>
                    <p>
                        عندما نحتاج إلى أية بيانات خاصة بك , فإننا سنطلب منك
                        تقديمها بمحض إرادتك. حيث ستساعدنا هذه المعلومات في
                        الاتصال بك وتنفيذ طلباتك حيثما كان ذلك ممكنناً. لن يتم
                        اطلاقاً بيع البيانات المقدمة من قبلك إلى أي طرف ثالث
                        بغرض تسويقها لمصلحته الخاصة دون الحصول على موافقتك
                        المسبقة والمكتوبة ما لم يتم ذلك على أساس أنها ضمن بيانات
                        جماعية تستخدم للأغراض الإحصائية والأبحاث دون اشتمالها
                        على أية بيانات من الممكن استخدامها للتعريف بك.
                    </p>
                </article>

                <article>
                    <h4>اخيرا</h4>
                    <p>
                        إن مخاوفك واهتمامك بشأن سرية وخصوصية البيانات تعتبر
                        مسألة في غاية الأهمية بالنسبة لنا.نحن نأمل أن يتم تحقيق
                        ذلك من خلال هذه السياسة.
                    </p>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
section {
    padding-top: 40px;
    background: #f2f2f2;
    min-height: 100vh;
    h1 {
        text-align: center;
        font-size: 60px;
        font-weight: bold;
    }

    .content {
        display: flex;
        justify-content: space-between;
        .side {
            width: 50%;
            padding: 60px;

            article {
                margin: 30px 0;
            }
        }
    }
}
</style>
